export const SET_CURRENT_DIR = '@UI/DIR/SET_CURRENT';
export const RESET_CURRENT_DIR = '@UI/DIR/RESET_CURRENT_DIR';
